import styled from "styled-components";
import C from "../assets/c";
import Java from "../assets/java";
import ReactIcon from "../assets/react-icon";
import NodeIcon from "../assets/node-icon";
import Ios from "../assets/ios";
import Android from "../assets/android";
import Python from "../assets/python";
import Flutter from "../assets/flutter";

const TechStacks = () => {
  return (
    <StyledTechStacks className="home_parent_wrapper">
      <div className="section_wrapper">
        <div className="content_wrapper">
          <h3>
            Languages <span>{`</>`}</span> our engineers speak
          </h3>
          <p>Regardless of your tech stack, there's a profile for you</p>
        </div>
        <div className="stack_wrapper">
          <div className="stack">
            <div className="stack_img">
              <Java />
            </div>
            <p>Java</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <ReactIcon />
            </div>
            <p>React</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <NodeIcon />
            </div>
            <p>Node.js</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <C />
            </div>
            <p>C#</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <Ios />
            </div>
            <p>iOS</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <Android />
            </div>
            <p>Android</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <Python />
            </div>
            <p>Python</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <img
                src="/images/golang.svg"
                alt="golang"
                width={80}
                height={70}
              />
            </div>
            <p>Golang</p>
          </div>
          <div className="stack">
            <div className="stack_img">
              <Flutter />
            </div>
            <p>Flutter</p>
          </div>
        </div>
      </div>
    </StyledTechStacks>
  );
};

const StyledTechStacks = styled.div`
  padding: 6.4rem 0;
  .section_wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5.3rem;
    align-items: center;
    padding: 8rem 4rem;
  }

  .content_wrapper h3 {
    font-size: 4.8rem;
    font-weight: 800;
    margin-bottom: 1.6rem;
  }

  .content_wrapper span {
    color: #34a853;
  }

  .stack_wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 27px;
    row-gap: 24px;
    text-align: center;
  }

  .stack_img {
    border-radius: 6px;
    box-shadow: 0px 5px 11px 0px rgba(189, 189, 189, 0.08),
      0px 20px 20px 0px rgba(189, 189, 189, 0.07),
      0px 45px 27px 0px rgba(189, 189, 189, 0.04),
      0px 79px 32px 0px rgba(189, 189, 189, 0.01),
      0px 124px 35px 0px rgba(189, 189, 189, 0);
    height: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .stack_wrapper p {
    margin-top: 4px;
    font-size: 1.6rem;
    font-weight: 600;
  }

  @media screen and (max-width: 750px) {
    padding: 4rem 0;
    .section_wrapper {
      padding: 8rem 0;
      display: grid;
      grid-template-columns: 1fr;
      gap: 3.2rem;
    }

    .content_wrapper h3 {
      font-size: 3.2rem;
    }

    .stack_img {
      height: 5.4rem;
    }

    .stack_img svg {
      width: 38px;
      height: 100%;
    }

    .stack_img img {
      width: 38px;
    }
  }
`;

export default TechStacks;
